export const kvizPitanjeTagsLista = [
    { title: 'Istorija' },
    { title: 'Geografija' },
    { title: 'Fizika' },
    { title: 'Hemija' },
    { title: 'Matematika' },
    { title: 'Biologija' },
    { title: 'Likovna umetnost' },
    { title: 'Muzika' },
    { title: 'Književnost' },
    { title: 'Srpski jezik' },
    { title: 'Film i pozorište' },
    { title: 'Sport' },
    { title: 'Biznis' },
    { title: 'Politika i pravo' },
    { title: 'Hobi' },
    { title: 'Kulinarstvo' },
    { title: 'Geologija' },
    { title: 'Građevinarstvo' },
    { title: 'Saobraćaj' },
    { title: 'Kombinovani transport' },
    { title: 'FTN' },
    { title: 'Ugostiteljstvo' },
    { title: 'Barsko poslovanje' },
    { title: 'Materijali u građevinarstvu' },
    { title: 'Putovanja' },
    { title: 'Prvi svetski rat' },
    { title: 'Drugi svetski rat' },
    { title: 'Nemanjići' },
    { title: 'Obrenovići' },
    { title: 'Karađorđevići' },
    { title: 'Crkva' },
    { title: 'Kosovska bitka' },
    { title: 'Balkanski ratovi' },
    { title: 'Sveti Sava' },
    { title: 'Jugoslavija' },
    { title: 'Opšte' },
    { title: 'Formula 1' },
    { title: 'Automobilizam' },
    { title: 'Automehanika' },
    { title: 'Ayrton Sena' },
    { title: 'Građevina' },
];
